import React from "react";
import { useNavigate } from "react-router-dom";
import { FiEdit, FiTrash2, FiPlay } from "react-icons/fi";
import { TRAINING_COURSE } from "../../../routes";
import { COURSE_STATUS } from "../constants";

const CourseCard = ({ course, isHR, onEdit, onDelete }) => {
  const navigate = useNavigate();

  const handleDelete = () => {
    if (!window.confirm("Are you sure you want to delete this course?")) return;
    onDelete(course.id);
  };

  const handleViewCourse = () => {
    navigate(`${TRAINING_COURSE}/${course.id}`);
  };

  const isCompleted = course.progress === 100;

  return (
    <div className="w-[420px] rounded-xl border bg-white shadow-sm overflow-hidden">
      {/* Image */}
      <img
        src={course.image}
        alt={course.title}
        className="h-48 w-full object-cover"
      />

      <div className="p-5">
        {/* Title */}
        <h3 className="py-1 text-base sm:text-lg font-semibold leading-snug overflow-hidden text-ellipsis [display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:2] sm:[-webkit-line-clamp:1]">
          {course.title}
        </h3>

        <p className="text-sm text-gray-600 mb-4 leading-snug overflow-hidden min-h-[40px] [display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:2] sm:[-webkit-line-clamp:2]">
          {course.description}
        </p>
        {/* Stats */}
        {/* Progress */}
        <div className="mb-2">
          <div className="flex justify-between text-xs mb-1">
            <span>
              {isCompleted ? COURSE_STATUS.COMPLETED : COURSE_STATUS.PROGRESS}
            </span>
            <span>{course.progress}%</span>
          </div>

          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className={`h-2 rounded-full transition-all ${
                course.progress === 100 ? "bg-green-600" : "bg-black"
              }`}
              style={{ width: `${course.progress}%` }}
            />
          </div>
        </div>

        {/* Actions */}
        {isHR ? (
          <div className="flex gap-3">
            {/* Training */}
            <button
              onClick={handleViewCourse}
              className="flex-1 flex items-center justify-center gap-2 py-2 bg-primary text-white rounded-lg font-semibold hover:bg-green-600"
            >
              <FiPlay />
              Training
            </button>
            <button
              onClick={onEdit}
              className="flex-1 flex items-center justify-center gap-2 py-2 bg-primary text-white rounded-lg font-semibold hover:bg-green-600"
            >
              <FiEdit />
              Edit
            </button>

            <button
              onClick={handleDelete}
              className="flex items-center justify-center p-2 border rounded-lg text-red-600 hover:bg-red-50"
            >
              <FiTrash2 />
            </button>
          </div>
        ) : (
          <button
            onClick={handleViewCourse}
            className="w-full flex items-center justify-center gap-2 py-2 bg-primary text-white rounded-lg font-semibold hover:bg-green-600"
          >
            <FiPlay />
            Training
          </button>
        )}
      </div>
    </div>
  );
};

export default CourseCard;
